import apple from '../assets/img/download/DownloadApple.svg';
import google from '../assets/img/download/DownloadGoogle.svg';
import { MaterialIcon } from "./materialIcon";
import { OpenInNewOutlined } from "@mui/icons-material";
import { Draw } from "./utils/draw";
import { JSX } from "react/jsx-runtime";
import { SolutionCard } from "../widgets/solutions/cards";
import { Duplicate } from "./utils/edit";

export class Solution implements Draw {
    private id: string;
    private categories: string[];
    private platforms: string[];
    private name: string;
    private shortDescription: {[key: string]: string};
    private externalLink: string;

    private logo: string;
    private presentationImg: string;

    private features: SolutionFeature[];

    private images: string[];
    private pricing: SolutionPricing[][];

    private longFeatures: {[key: string]: any}[];
    private users: SolutionUser[];

    private slogang: {[key: string]: string};

    private imagesChanged:boolean|number[] = false;
    private logoChanged:boolean=false;
    private presentationImgChanged:boolean=false;
    private beforeId:string|null = null;
    private idChanged:boolean = false;

    constructor(id:string, categories: string[], platforms: string[], name: string, shortDescription: {[key: string]: string}, externalLink: string, logo: string, features: SolutionFeature[], images: string[], pricing: SolutionPricing[][], longFeatures: {[key: string]: any}[], users: SolutionUser[], slogang: {[key: string]: string}, presentationImg: string) {
        this.setId(id);
        this.setCategories(categories);
        this.setPlatforms(platforms);
        this.setName(name);
        this.setShortDescription(shortDescription);
        this.setExternalLink(externalLink);
        this.setLogo(logo);
        this.setFeatures(features);
        this.setImages(images);
        this.setPricing(pricing);
        this.setLongFeatures(longFeatures);
        this.setUsers(users);
        this.setSlogang(slogang);
        this.setPresentationImg(presentationImg);
    }

    static fromJSON(json: any, id:string) {
        const features = json.features.map((feature:any) => SolutionFeature.fromJSON(feature));
        var newPricing: SolutionPricing[][] = [];

        const val = json.pricing.map((pricing:any) => {
            var actualPricing: SolutionPricing[] = [];
            const vali = pricing.pricing.map((price:any) => {
                console.log(price);
                const solPrice = SolutionPricing.fromJSON(price);
                console.log(solPrice);
                actualPricing.push(solPrice);
                return '';
            });
            newPricing.push(actualPricing);
            return '';
        });

        const users = json.ourUsers.map((user:any) => SolutionUser.fromJSON(user));

        return new Solution(id, json.categories, json.platforms, json.name, json.shortDescription, json.externalLink, json.logo, features, json.images, newPricing, json.longFeatures, users, json.slogang, json.presentationImg);
    }

    private setId(id: string) {
        this.id = id;
    }
    setCategories(categories: string[]) {
        this.categories = categories;
    }
    setPlatforms(platforms: string[]) {
        this.platforms = platforms;
    }
    setName(name: string) {
        const trimmedName = name.trim();
        this.name = trimmedName.length > 0 ? trimmedName : 'Title';
        console.log('Name set to:', this.name);
    }
    setShortDescription(shortDescription: {[key: string]: string}) {
        this.shortDescription = shortDescription;
    }
    setExternalLink(externalLink: string) {
        this.externalLink = externalLink;
    }
    setLogo(logo: string) {
        this.logo = logo;
    }
    setFeatures(features: SolutionFeature[]) {
        this.features = features;
    }
    setImages(images: string[]) {
        this.images = images;
    }
    setPricing(pricing: SolutionPricing[][]) {
        this.pricing = pricing;
    }
    setLongFeatures(longFeatures: {[key: string]: any}[]) {
        this.longFeatures = longFeatures;
    }
    setUsers(users: SolutionUser[]) {
        this.users = users;
    }
    setSlogang(slogang: {[key: string]: string}) {
        this.slogang = slogang;
    }
    setPresentationImg(presentationImg: string) {
        this.presentationImg = presentationImg;
    }
    private setImagesChanged(imageChanged:boolean|number[]) {
        this.imagesChanged = imageChanged;
    }
    private setLogoChanged(logoChanged:boolean) {
        this.logoChanged = logoChanged;
    }
    private setPresentationImgChanged(presentationImgChanged:boolean) {
        this.presentationImgChanged = presentationImgChanged;
    }
    private setBeforeId(beforeId:string|null) {
        this.beforeId = beforeId;
    }
    private setIdChanged(idChanged:boolean) {
        this.idChanged = idChanged;
    }

    getId() {
        return this.id;
    }
    getCategories() {
        return this.categories;
    }
    getPlatforms() {
        return this.platforms;
    }
    getName() {
        return this.name;
    }
    getShortDescription() {
        return this.shortDescription;
    }
    getExternalLink() {
        return this.externalLink;
    }
    getLogo() {
        return this.logo;
    }
    getFeatures() {
        return this.features;
    }
    getImages() {
        return this.images;
    }
    getPricing() {
        return this.pricing;
    }
    getLongFeatures() {
        return this.longFeatures;
    }
    getUsers() {
        return this.users;
    }
    getSlogang() {
        return this.slogang;
    }
    getPresentationImg() {
        return this.presentationImg;
    }
    getImagesChanged() {
        return this.imagesChanged;
    }
    getLogoChanged() {
        return this.logoChanged;
    }
    getPresentationImgChanged() {
        return this.presentationImgChanged;
    }
    getBeforeId() {
        return this.beforeId;
    }
    getIdChanged() {
        return this.idChanged;
    }

    getShortDescriptionByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.shortDescription['en'];
            case 'es':
                return this.shortDescription['es'];
            case 'ca':
                return this.shortDescription['ca'];
            default:
                return this.shortDescription['en'];
        }
    }
    getDowloadMobileLinks() {
        const platforms = this.getPlatforms();

        if (platforms.includes('Android') || platforms.includes('iOS')) {
            return <div className="solution-download-buttons">
                {platforms.includes('Android')
                    ? <a href="/" className="app-store-btn">
                        <img src={apple} alt="Download on the App Store"/>
                    </a>
                    : null
                }
                {platforms.includes('iOS')
                    ? <a href="/" className="google-play-btn">
                        <img src={google} alt="Get it on Google Play"/>
                    </a>
                    : null
                }
            </div>;
        } else {
            return null;
        }
    }
    getWebsiteLink(t) {
        if (this.externalLink !== null && this.externalLink !== undefined && this.externalLink !== '') {
            return <a href={this.externalLink} style={{color: 'white', textDecoration: 'none'}} target="_blank">{t('solutions.page.learnMore')} <span><OpenInNewOutlined/></span></a>
        } else {
            return null;
        }
    }
    getLongFeatureByLang(lang:string, index:number) {
        switch (lang) {
            case 'en':
                return this.longFeatures[index].text.en;
            case 'es':
                return this.longFeatures[index].text.es;
            case 'ca':
                return this.longFeatures[index].text.ca;
            default:
                return this.longFeatures[index].text.en;
        }
    }
    getSlogangByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.slogang.en;
            case 'es':
                return this.slogang.es;
            case 'ca':
                return this.slogang.ca;
            default:
                return this.slogang.en;
        }
    }

    changeLogo(logo: string) {
        this.setLogo(logo);
        this.setLogoChanged(true);
    }
    changePresentationImg(presentationImg: string) {
        this.setPresentationImg(presentationImg);
        this.setPresentationImgChanged(true);
    }
    changeImage(image: string, index:number) {
        const auxImages = this.getImages();
        auxImages[index] = image;

        var auxChanged = this.getImagesChanged();
        if (Array.isArray(auxChanged)) {
            auxChanged.push(index);
        } else {
            auxChanged = [index];
        }

        this.setImages(auxImages);
        this.setImagesChanged(auxChanged);
    }
    deleteImage(index:number) {
        console.log(index, this.images);
        const newArr:string[] = [];
        if (this.images.length-1 >= index) {
            for (var i=0; i<this.images.length; i++) {
                if (i !== index) {
                    newArr.push(this.images[i]);
                }
            }
            this.setImages(newArr);
            console.log(this.images);
        }
    }
    addImage(image: string) {
        this.images.push(image);
    }

    deletePrice(index:number, indexi:number) {
        const newPricing:SolutionPricing[][] = [];
        for (var i=0; i<this.pricing.length; i++) {
            if (i !== index) {
                newPricing.push(this.pricing[i]);
            } else {
                const newPricingI:SolutionPricing[] = [];
                for (var ii=0; ii<this.pricing[i].length; ii++) {
                    if (ii !== indexi) {
                        newPricingI.push(this.pricing[i][ii]);
                    }
                }
                newPricing.push(newPricingI);
            }
        }
        this.setPricing(newPricing);
    }
    duplicatePrice(index:number, indexi:number) {
        this.pricing[index].push(this.pricing[index][indexi].duplicate());
    }
    addPrice(index:number) {
        this.pricing[index].push(new SolutionPricing(false, new SolutionPrice({eur: '0'}, {en: 'month', es: 'mes', ca: 'mes'}), undefined, [], {en: 'Title', es: 'Título', ca: 'Títol'}));
    }
    addSectionPrice() {
        this.pricing.push([]);
    }
    deleteSectionPrice(index:number) {
        const newPricing:SolutionPricing[][] = [];
        for (var i=0; i<this.pricing.length; i++) {
            if (i !== index) {
                newPricing.push(this.pricing[i]);
            }
        }
        this.pricing = newPricing;
    }
    duplicateSectionPrice(index:number) {
        const newPricingI:SolutionPricing[] = [];
        for (var ii=0; ii<this.pricing[index].length; ii++) {
            newPricingI.push(this.pricing[index][ii].duplicate());
        }
        this.pricing.push(newPricingI);
    }

    createFeature(id: string, icon: string|null = null, title: {[key:string]:string}={ca: 'Títol', es: 'Título', en: 'Title'}, description: {[key:string]:string}={ca: 'Descripció', es: 'Descripción', en: 'Description'}) {
        this.features.push(new SolutionFeature(id, null, title, description));
    }
    containsFeature(id: string) {
        for (const feature of this.features) {
            if (feature.getId() === id) {
                return true;
            }
        }
        return false;
    }
    deleteFeature(index:number) {
        const newFeatures:SolutionFeature[] = [];
        for (var i=0; i<this.features.length; i++) {
            if (i !== index) {
                newFeatures.push(this.features[i]);
            }
        }
        this.setFeatures(newFeatures);
    }
    moveFeatureLeft(index:number) {
        const auxFeature:SolutionFeature = this.features[index-1];
        this.features[index-1] = this.features[index];
        this.features[index] = auxFeature;
    }
    moveFeatureRight(index:number) {
        const auxFeature:SolutionFeature = this.features[index+1];
        this.features[index+1] = this.features[index];
        this.features[index] = auxFeature;
    }

    moveFeatureSectionUp(index:number) {
        const auxPricing:SolutionPricing[] = this.pricing[index-1];
        this.pricing[index-1] = this.pricing[index];
        this.pricing[index] = auxPricing;
    }
    moveFeatureSectionDown(index:number) {
        const auxPricing:SolutionPricing[] = this.pricing[index+1];
        this.pricing[index+1] = this.pricing[index];
        this.pricing[index] = auxPricing;
    }
    movePriceRight(index:number, indexi) {
        const auxPrice:SolutionPricing = this.pricing[index][indexi];
        this.pricing[index][indexi] = this.pricing[index][indexi+1];
        this.pricing[index][indexi+1] = auxPrice;
    }
    movePriceLeft(index:number, indexi) {
        const auxPrice:SolutionPricing = this.pricing[index][indexi];
        this.pricing[index][indexi] = this.pricing[index][indexi-1];
        this.pricing[index][indexi-1] = auxPrice;
    }

    getAllFeaturesId() {
        const featuresId:string[] = [];
        for (const feature of this.features) {
            if (feature.getId() !== undefined && feature.getId() !== null && feature.getId().length > 0) {
                featuresId.push(feature.getId());
            }
        }
        return featuresId;
    }
    createLargeFeature() {
        this.longFeatures.push({id: '', text: {ca: 'Text', es: 'Texto', en: 'Text'}});
    }

    moveImageLeft(index:number) {
        const auxImage:string = this.images[index-1];
        this.images[index-1] = this.images[index];
        this.images[index] = auxImage;
    }
    moveImageRight(index:number) {
        const auxImage:string = this.images[index+1];
        this.images[index+1] = this.images[index];
        this.images[index] = auxImage;
    }

    addUser() {
        this.users.push(new SolutionUser('User', {ca: 'Text', es: 'Texto', en: 'Text'}, {ca: 'Descripció', es: 'Descripción', en: 'Description'}, 'user'));
    }
    deleteUser(index:number) {
        const newUsers:SolutionUser[] = [];
        for (var i=0; i<this.users.length; i++) {
            if (i !== index) {
                newUsers.push(this.users[i]);
            }
        }
        this.setUsers(newUsers);
    }
    moveUserLeft(index:number) {
        const auxUser:SolutionUser = this.users[index-1];
        this.users[index-1] = this.users[index];
        this.users[index] = auxUser;
    }
    moveUserRight(index:number) {
        const auxUser:SolutionUser = this.users[index+1];
        this.users[index+1] = this.users[index];
        this.users[index] = auxUser;
    }

    updateId(id:string) {
        this.setBeforeId(this.getId());
        this.setId(id);
        this.setIdChanged(true);
    }

    complateDrow(): JSX.Element {
        return <div>
            
        </div>;
    }
    cardDraw(): JSX.Element {
        return <SolutionCard solution={this}/>;
    }
}

export class SolutionFeature {
    private id: string;
    private icon: string|null;
    private title: {[key: string]: string};
    private description: {[key: string]: string};

    constructor(id: string, icon: string|null, title: {[key: string]: string}, description: {[key: string]: string}) {
        this.setId(id);
        this.setIcon(icon);
        this.setTitle(title);
        this.setDescription(description);
    }

    static fromJSON(json: any) {
        return new SolutionFeature(json.id, json.icon, json.title, json.text);
    }

    setId(id: string) {
        this.id = id;
    }
    setIcon(icon: string|null) {
        this.icon = icon;
    }
    setTitle(title: {[key: string]: string}) {
        this.title = title;
    }
    setDescription(description: {[key: string]: string}) {
        this.description = description;
    }

    getId() {
        return this.id;
    }
    getIcon() {
        return this.icon;
    }
    getTitle() {
        return this.title;
    }
    getDescription() {
        return this.description;
    }

    getTitleByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.title.en;
            case 'es':
                return this.title.es;
            case 'ca':
                return this.title.ca;
            default:
                return this.title.en;
        }
    }
    getDescriptionByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.description.en;
            case 'es':
                return this.description.es;
            case 'ca':
                return this.description.ca;
            default:
                return this.description.en;
        }
    }
    getMaterialIcon() {
        return <MaterialIcon icon={this.getIcon()}/>;
    }
}

export class SolutionPricing implements Duplicate {
    private active: boolean;
    private primary: SolutionPrice;
    private secondary: SolutionPrice | null | undefined;
    private features: {[key: string]: string}[];
    private title: {[key: string]: string};

    constructor(active: boolean, primary: SolutionPrice, secondary: SolutionPrice | null | undefined, features: {[key: string]: string}[], title: {[key: string]: string}) {
        this.setActive(active);
        this.setPrimary(primary);
        this.setSecondary(secondary);
        this.setFeatures(features);
        this.setTitle(title);
    }

    static fromJSON(json: any) {
        return new SolutionPricing(json.active, SolutionPrice.fromJSON(json.price.primary), json.price.secondary !== undefined? SolutionPrice.fromJSON(json.price.secondary) : undefined, json.features, json.title);
    }

    setActive(active: boolean) {
        this.active = active;
    }
    setPrimary(primary: SolutionPrice) {
        this.primary = primary;
    }
    setSecondary(secondary: SolutionPrice | null | undefined) {
        this.secondary = secondary;
    }
    setFeatures(features: {[key: string]: string}[]) {
        this.features = features;
    }
    setTitle(title: {[key: string]: string}) {
        this.title = title;
    }

    getActive() {
        return this.active;
    }
    getPrimary() {
        return this.primary;
    }
    getSecondary() {
        return this.secondary;
    }
    getFeatures() {
        return this.features;
    }
    getTitle() {
        return this.title;
    }

    getTitleByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.title.en;
            case 'es':
                return this.title.es;
            case 'ca':
                return this.title.ca;
            default:
                return this.title.en;
        }
    }
    getFeaturesByLang(lang:string, index:number) {
        switch (lang) {
            case 'en':
                return this.features[index].en;
            case 'es':
                return this.features[index].es;
            case 'ca':
                return this.features[index].ca;
            default:
                return this.features[index].en;
        }
    }

    updateFeature(index:number, feature:{[key: string]: string}) {
        this.features[index] = feature;
    }
    createFeature() {
        this.features.push({ca:'Nova característica', es:'Nueva característica', en:'New feature'});
    }
    deleteFeature(index:number) {
        const newFeatures:{[key: string]: string}[] = [];
        for (var i=0; i<this.features.length; i++) {
            if (i !== index) {
                newFeatures.push(this.features[i]);
            }
        }
        this.setFeatures(newFeatures);
    }
    moveFeatureUp(index:number) {
        const auxFeature:{[key: string]: string} = this.features[index-1];
        this.features[index-1] = this.features[index];
        this.features[index] = auxFeature;
    }
    moveFeatureDown(index:number) {
        const auxFeature:{[key: string]: string} = this.features[index+1];
        this.features[index+1] = this.features[index];
        this.features[index] = auxFeature;
    }

    duplicate():SolutionPricing {
        return new SolutionPricing(this.active, this.primary.duplicate(), this.secondary !== null && this.secondary !== undefined ? this.secondary.duplicate() : undefined, this.features, this.title);
    }
}

export class SolutionPrice implements Duplicate {
    private value: {[key: string]: string};
    private period: {[key: string]: string};
    
    constructor(value: {[key: string]: string}, period: {[key: string]: string}) {
        this.setValue(value);
        this.setPeriod(period);
    }

    static fromJSON(json: any) {
        return new SolutionPrice(json.value, json.period);
    }

    setValue(value: {[key: string]: string}) {
        this.value = value;
    }
    setPeriod(period: {[key: string]: string}) {
        this.period = period;
    }

    getValue() {
        return this.value;
    }
    getPeriod() {
        return this.period;
    }

    getValueByCurrency(currency:string) {
        switch (currency) {
            case 'eur':
            return this.value.eur;
            default:
                return this.value.eur;
        }
    }
    getPeriodByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.period.en;
            case 'es':
                return this.period.es;
            case 'ca':
                return this.period.ca;
            default:
                return this.period.en;
        }
    }

    duplicate():SolutionPrice {
        return new SolutionPrice(this.value, this.period);
    }
}

export class SolutionUser {
    private name: string;
    private text: {[key: string]: string};
    private description: {[key: string]: string};
    private photo: string;

    private avatarChnaged: boolean = false;

    constructor(name: string, text: {[key: string]: string}, description: {[key: string]: string}, photo: string) {
        this.setName(name);
        this.setText(text);
        this.setDescription(description);
        this.setPhoto(photo);
    }

    static fromJSON(json: any) {
        return new SolutionUser(json.name, json.text, json.description, json.photo);
    }

    setName(name: string) {
        this.name = name;
    }
    setText(text: {[key: string]: string}) {
        this.text = text;
    }
    setDescription(description: {[key: string]: string}) {
        this.description = description;
    }
    private setPhoto(photo: string) {
        this.photo = photo;
    }
    private setAvatarChnaged(avatarChnaged: boolean) {
        this.avatarChnaged = avatarChnaged;
    }

    getName() {
        return this.name;
    }
    getText() {
        return this.text;
    }
    getDescription() {
        return this.description;
    }
    getPhoto() {
        return this.photo;
    }
    getAvatarChnaged() {
        return this.avatarChnaged;
    }

    getTextByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.text.en;
            case 'es':
                return this.text.es;
            case 'ca':
                return this.text.ca;
            default:
                return this.text.en;
        }
    }
    getDescriptionByLang(lang:string) {
        switch (lang) {
            case 'en':
                return this.description.en;
            case 'es':
                return this.description.es;
            case 'ca':
                return this.description.ca;
            default:
                return this.description.en;
        }
    }

    deletePhoto() {
        this.photo = 'user';
    }
    changePhoto(photo: string) {
        this.setPhoto(photo);
        this.setAvatarChnaged(true);
    }
}